export default __webpack_public_path__ + "static/media/home-digital-agency-img-07.04ca2840.jpg";